import type { VueRoute } from "ui-kit/RouterVue";
import { h } from "vue";

const route: VueRoute = {
  path: "/contacts/:slug?",
  action: async ({ pathname }) => {
    const id = pathname.groups.slug;
    if (id === "matching") {
      const c = await import("./views/contactsMatching.vue");
      return h(c.default);
    }
    const c = id
      ? await import("./views/contactEdit.vue")
      : await import("./views/contacts.vue");
    return h(c.default, { id });
  },
};

export default route;
